export const RGBtoRGBA = (colorRGB: string, alpha: number) => colorRGB.replace('rgb', 'rgba').replace(')', `, ${alpha})`)
